module.exports = __webpack_public_path__ + "static/media/Logo.375e3ee5.png";